export default __webpack_public_path__ + "static/media/configgraph.4c12faa5.png";